import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  handleScrollToBottom,
} from "../../../appStore/actions/AppState/action";
import {
  handleDeleteGroupMessage,
  handleGetStarMessages,
  handleGetThreadMessage,
  handleStarMessage,
} from "../../../appStore/actions/ArkchatGroup/action";
import { groupMsgDeleteType } from "../../../utils/constant";
import TempMessageView from "./TempMessageView";
import MessageThread from "./MessageThread";
import session, { findUser, showMemberProfile } from "../../../utils/helper";
import { getUserProfileDetails } from "../../../appStore/actions/AppState/action";
import ProfileDetailModal from "../../../common/ProfileDetailModal";
import SearchInputFromGroupInfo from "../Tabs/SearchInputFromGroupInfo";

const MessageThreadList = ({
  messageList,
  setMediaFilesOpen,
  setReplyParentMsg,
  handlegetThreadMessages,
  handleBacktoMessage,
  setMoveTopicTriggered,
  setMoveTopicMsgId,
  setisTopicOpen,
  handleReadStatusDrawer,
  handleSendTempMsg,
  handleClickTaskUpdate,
  isTopicOpen,
  progress,
  isSearchGroupInfoOpen,
  handleSearch,
  handleAddgroupMember,
  isPrivateChatOn,
  searchInputValue,
  handleSearchInputChange,
  highlightText,
  filteredMessageList,
  onPreviewFile,
}) => {
  const userData = useSelector((state) => state?.profile);
  const tempMsgList = useSelector(
    (state) => state?.arkchatgroup?.tempMessageList
  );
  const selectedTopic = useSelector(
    (state) => state?.appStateData?.selectedTopicData
  );
  const selectedGroup = useSelector(
    (state) => state?.appStateData?.selectedGroupData
  );
  const groupmemberdetails = useSelector(
    (state) => state?.arkchatgroup?.groupmember
  );
  const showStarMessage = useSelector(
    (state) => state?.appStateData?.showStarMessage
  );
  const isScrollToBottom = useSelector(
    (state) => state?.appStateData?.isScrollToBottom
  );
  const isThreadScrollToBottom = useSelector(
    (state) => state?.appStateData?.isThreadScrollToBottom
  );
  const starMsgData = useSelector((state) => state?.arkchatgroup?.starMsgData);
  const threadMsgList = useSelector(
    (state) => state?.arkchatgroup?.threadMsgList
  );
  // The thread's root message always sits at index 0 with thread_id === null
  // (see handleGetThreadMessage / RECEIVED_THREAD_MESSAGES).
  const threadParentId = threadMsgList?.find((m) => !m?.thread_id)?.id;

  const threadContainerRef = useRef(null);
  const menuRef = useRef(null);
  const threeDotRef = useRef(null);
  const isLoadingOldMsgRef = useRef(false);
  const hasReachedEndRef = useRef(false);
  const prevScrollHeightRef = useRef(null);
  // Page 1 is always loaded by the initial thread open (handlegetThreadMessages),
  // so the next scroll-up load-more starts at page 2.
  const threadPageRef = useRef(2);
  const [isMoreMenuOpen, setMoreMenu] = useState(false);
  const [isDeleteGroupMsgOpen, setDeleteGroupMsgOpen] = useState(false);
  const [isDeleteGroupMsgOpenIndicatorId, setDeleteGroupMsgOpenIndicatorId] =
    useState(null);
  const [deleteGrpMsgType, setDeleteGrpMsgType] = useState("");
  const [isScrollingToTop, setIsScrollingToTop] = useState(false);
  const [highlightedMessageId, setHighlightedMessageId] = useState(null);
  const [profileViewData, setProfileViewData] = useState("");
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [startTaskOpen, setStartTaskOpen] = useState(null);
  const dispatch = useDispatch();
  const isThreadScreen = session.get("isThreadScreen");

  ////////
  const scrollToBottom = () => {
    if (
      threadContainerRef?.current &&
      isThreadScreen &&
      isThreadScrollToBottom
    ) {
      threadContainerRef.current.scrollTop =
        threadContainerRef.current.scrollHeight;
    }
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMoreMenu(null);
    }
  };
  const toggleItemMenu = (item) => {
    if (isMoreMenuOpen?.timetoken === item?.timetoken) {
      setMoreMenu(null);
    } else {
      setMoreMenu(item);
    }
  };

  const handleDeleteGrpMsg = (msgData) => {
    if (deleteGrpMsgType === groupMsgDeleteType?.me) {
      dispatch(handleDeleteGroupMessage(msgData, false)).then((res) => {});
      setDeleteGrpMsgType("");
      setDeleteGroupMsgOpen(false);
      setDeleteGroupMsgOpenIndicatorId(null);
    } else if (deleteGrpMsgType === groupMsgDeleteType?.all) {
      dispatch(handleDeleteGroupMessage(msgData, true)).then((res) => {});
      setDeleteGrpMsgType("");
      setDeleteGroupMsgOpen(false);
      setDeleteGroupMsgOpenIndicatorId(null);
    }
  };
  const handleStarUnstarMsg = (timetoken) => {
    const reqBoby = {
      pn_id: selectedGroup?.pnId,
      timetoken: timetoken,
    };
    dispatch(
      handleStarMessage(
        reqBoby,
        selectedGroup?.pnId,
        selectedTopic,
        messageList,
        isThreadScreen
      )
    ).then((res) => {
      if (res?.status) {
        // The message's star (starred_by) comes from the reply, and the
        // star signal updates other devices and the Starred screen.
        setMoreMenu(null);
      }
    });
  };
  const handleStartTask = (item) => {
    if (startTaskOpen?.timetoken === item?.timetoken) {
      setStartTaskOpen(null);
    } else {
      setStartTaskOpen(item);
    }
  };

  const scrollToRepliedMessage = (messageId) => {
    setHighlightedMessageId(messageId);
    setTimeout(() => {
      setHighlightedMessageId(null);
    }, 2000);

    const repliedMessageElement = document.getElementById(
      `replied-message-${messageId}`
    );
    if (repliedMessageElement) {
      repliedMessageElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Runs synchronously after DOM updates, before paint — keeps viewport anchored
  // when messages are prepended above the visible area.
  useLayoutEffect(() => {
    const container = threadContainerRef.current;
    if (!container || prevScrollHeightRef.current === null) return;
    const delta = container.scrollHeight - prevScrollHeightRef.current;
    if (delta > 0) {
      container.scrollTo({ top: container.scrollTop + delta, behavior: "instant" });
      prevScrollHeightRef.current = null;
    }
  }, [messageList]);

  const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  };
  ////
  const handleScroll = debounce(() => {
    const activeChannel = selectedGroup?.pnId;

    if (threadContainerRef?.current) {
      const { scrollTop } = threadContainerRef.current;
      let shouldConsiderScrollTop = false;

      if (messageList?.length > 0) {
        shouldConsiderScrollTop = messageList[0]?.pnId === activeChannel;
      }

      const isNearTop =
        scrollTop <= 201 && shouldConsiderScrollTop && messageList?.length > 20;

      if (isScrollingToTop !== isNearTop) {
        setIsScrollingToTop(isNearTop);
      }
    }
  }, 50);
  /////
  // Reset all load guards whenever the selected group/channel or the open thread changes
  useEffect(() => {
    isLoadingOldMsgRef.current = false;
    hasReachedEndRef.current = false;
    prevScrollHeightRef.current = null;
    threadPageRef.current = 2;
  }, [selectedGroup?.pnId, threadParentId]);

  useEffect(() => {
    if (!isScrollingToTop || isLoadingOldMsgRef.current || hasReachedEndRef.current) return;
    isLoadingOldMsgRef.current = true;
    dispatch(handleScrollToBottom(false));

    const container = threadContainerRef.current;
    if (!container) {
      isLoadingOldMsgRef.current = false;
      setIsScrollingToTop(false);
      return;
    }

    const finishLoad = () => {
      isLoadingOldMsgRef.current = false;
      setIsScrollingToTop(false);
    };

    if (showStarMessage) {
      const currentScrollPosition = container.scrollHeight - container.scrollTop;
      const page = Math.floor(starMsgData?.messages?.length / 50) + 1;
      dispatch(handleGetStarMessages(selectedGroup?.pnId, page)).then(() => {
        setTimeout(() => {
          container.scrollTo({ top: container.scrollHeight - currentScrollPosition, behavior: "instant" });
          finishLoad();
        }, 0);
      });
    } else if (!threadParentId) {
      isLoadingOldMsgRef.current = false;
      setIsScrollingToTop(false);
    } else {
      prevScrollHeightRef.current = container.scrollHeight;
      const pageToLoad = threadPageRef.current;

      dispatch(handleGetThreadMessage({ thread_id: threadParentId }, pageToLoad)).then(
        (res) => {
          if (res === null) {
            // Network/request error — clear the snapshot and allow a future retry.
            prevScrollHeightRef.current = null;
            finishLoad();
            return;
          }
          const olderMessages = res?.data?.messages || [];
          if (olderMessages.length > 0) {
            threadPageRef.current = pageToLoad + 1;
            finishLoad();
          } else {
            // Server confirmed no more history for this thread.
            prevScrollHeightRef.current = null;
            hasReachedEndRef.current = true;
            finishLoad();
          }
        }
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScrollingToTop]);

  /////
  useEffect(() => {
    if (isScrollToBottom || isThreadScrollToBottom) {
      scrollToBottom();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageList, tempMsgList]);

  const handleShowUserProfile = (userToFindData) => {
    showMemberProfile(
      findUser(groupmemberdetails, userToFindData),
      userToFindData,
      (userId) => dispatch(getUserProfileDetails(userId)),
      setProfileViewData,
      setProfileViewModal,
    );
  };
  return (
    <>
      <ProfileDetailModal
        setProfileViewModal={setProfileViewModal}
        isProfileViewOpen={isProfileViewOpen}
        profileViewData={profileViewData}
        setProfileViewData={setProfileViewData}
      />

      {isSearchGroupInfoOpen && (
        <Box
          display={"flex"}
          space={2}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <SearchInputFromGroupInfo
            setMediaFilesOpen={setMediaFilesOpen}
            handleBacktoMessage={handleBacktoMessage}
            handleSearch={handleSearch}
            searchInputValue={searchInputValue}
            handleSearchInputChange={handleSearchInputChange}
            type="thread"
            filteredMessageList={filteredMessageList}
          />
        </Box>
      )}

      {/* <Box borderBottom={"1px solid"}>
        {threadMsgList?.length > 0 && (
          <MessageThread
            item={threadMsgList[0]}
            key={threadMsgList[0]?.temp_timetoken + "ThreadmessageViewList"}
            isMoreMenuOpen={isMoreMenuOpen}
            startTaskOpen={startTaskOpen}
            setStartTaskOpen={setStartTaskOpen}
            handleStartTask={handleStartTask}
            threeDotRef={threeDotRef}
            userData={userData}
            isDeleteGroupMsgOpenIndicatorId={isDeleteGroupMsgOpenIndicatorId}
            handleClickTaskUpdate={handleClickTaskUpdate}
            isDeleteGroupMsgOpen={isDeleteGroupMsgOpen}
            handleReadStatusDrawer={handleReadStatusDrawer}
            setisTopicOpen={setisTopicOpen}
            setMoveTopicMsgId={setMoveTopicMsgId}
            setMoveTopicTriggered={setMoveTopicTriggered}
            setDeleteGroupMsgOpenIndicatorId={setDeleteGroupMsgOpenIndicatorId}
            setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
            handlegetThreadMessages={handlegetThreadMessages}
            setMoreMenu={setMoreMenu}
            menuRef={menuRef}
            isThreadScreen={isThreadScreen}
            selectedGroup={selectedGroup}
            toggleItemMenu={toggleItemMenu}
            handleStarUnstarMsg={handleStarUnstarMsg}
            handleDeleteGrpMsg={handleDeleteGrpMsg}
            setDeleteGrpMsgType={setDeleteGrpMsgType}
            handleShowUserProfile={handleShowUserProfile}
            bgcolor={
              highlightedMessageId === threadMsgList[0]?.temp_timetoken
                ? "#F9F8F8"
                : "transparent"
            }
            scrollToRepliedMessage={scrollToRepliedMessage}
            hideBottonLine={true}
          />
        )}
      </Box> */}

      <Box
        maxWidth={"100%"}
        sx={{
          position: "relative",
          height: "100%",
          overflow: "auto",
          scrollBehavior: "smooth",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "3px",
          },
        }}
        ref={threadContainerRef}
        onScroll={handleScroll}
      >
        {/* {(searchInputValue ? filteredMessageList : threadMsgList)?.length > 0 &&
          (searchInputValue ? filteredMessageList : threadMsgList)?.map(
            (item, i) => (
              <MessageThread
                item={item}
                key={item?.temp_timetoken + "ThreadmessageViewList"}
                isMoreMenuOpen={isMoreMenuOpen}
                startTaskOpen={startTaskOpen}
                setStartTaskOpen={setStartTaskOpen}
                handleStartTask={handleStartTask}
                threeDotRef={threeDotRef}
                userData={userData}
                isDeleteGroupMsgOpenIndicatorId={
                  isDeleteGroupMsgOpenIndicatorId
                }
                handleClickTaskUpdate={handleClickTaskUpdate}
                isDeleteGroupMsgOpen={isDeleteGroupMsgOpen}
                handleReadStatusDrawer={handleReadStatusDrawer}
                setisTopicOpen={setisTopicOpen}
                setMoveTopicMsgId={setMoveTopicMsgId}
                setMoveTopicTriggered={setMoveTopicTriggered}
                setDeleteGroupMsgOpenIndicatorId={
                  setDeleteGroupMsgOpenIndicatorId
                }
                setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
                handlegetThreadMessages={handlegetThreadMessages}
                setMoreMenu={setMoreMenu}
                menuRef={menuRef}
                isThreadScreen={isThreadScreen}
                selectedGroup={selectedGroup}
                toggleItemMenu={toggleItemMenu}
                handleStarUnstarMsg={handleStarUnstarMsg}
                handleDeleteGrpMsg={handleDeleteGrpMsg}
                setDeleteGrpMsgType={setDeleteGrpMsgType}
                handleShowUserProfile={handleShowUserProfile}
                highlightText={highlightText}
                searchInputValue={searchInputValue}
                bgcolor={
                  highlightedMessageId === item?.temp_timetoken
                    ? "#F9F8F8"
                    : "transparent"
                }
                scrollToRepliedMessage={scrollToRepliedMessage}
              />
            )
          )} */}
        {threadMsgList?.length > 0 &&
          threadMsgList?.map((item, i) => (
            <MessageThread
              item={item}
              key={item?.temp_timetoken + "ThreadmessageViewList"}
              isMoreMenuOpen={isMoreMenuOpen}
              startTaskOpen={startTaskOpen}
              setStartTaskOpen={setStartTaskOpen}
              handleStartTask={handleStartTask}
              threeDotRef={threeDotRef}
              userData={userData}
              isDeleteGroupMsgOpenIndicatorId={isDeleteGroupMsgOpenIndicatorId}
              handleClickTaskUpdate={handleClickTaskUpdate}
              isDeleteGroupMsgOpen={isDeleteGroupMsgOpen}
              handleReadStatusDrawer={handleReadStatusDrawer}
              setisTopicOpen={setisTopicOpen}
              setMoveTopicMsgId={setMoveTopicMsgId}
              setMoveTopicTriggered={setMoveTopicTriggered}
              setDeleteGroupMsgOpenIndicatorId={
                setDeleteGroupMsgOpenIndicatorId
              }
              setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
              handlegetThreadMessages={handlegetThreadMessages}
              setMoreMenu={setMoreMenu}
              menuRef={menuRef}
              isThreadScreen={isThreadScreen}
              selectedGroup={selectedGroup}
              toggleItemMenu={toggleItemMenu}
              handleStarUnstarMsg={handleStarUnstarMsg}
              handleDeleteGrpMsg={handleDeleteGrpMsg}
              setDeleteGrpMsgType={setDeleteGrpMsgType}
              handleShowUserProfile={handleShowUserProfile}
              highlightText={highlightText}
              searchInputValue={searchInputValue}
              bgcolor={
                highlightedMessageId === item?.temp_timetoken
                  ? "#F9F8F8"
                  : "transparent"
              }
              scrollToRepliedMessage={scrollToRepliedMessage}
              onPreviewFile={onPreviewFile}
            />
          ))}

        {tempMsgList?.length > 0 &&
          selectedGroup?.isGroup &&
          tempMsgList?.map((item, i) => (
            <TempMessageView
              selectedGroup={selectedGroup}
              item={item}
              key={item?.temp_timetoken + "tempMsg"}
              threeDotRef={threeDotRef}
              userData={userData}
              handleSendTempMsg={handleSendTempMsg}
              progress={progress}
            />
          ))}
      </Box>
      {/* Floating PersonFloat Button */}
      {/* {selectedGroup?.isGroup && isPrivateChatOn ? (
        <Box
          onClick={handleAddgroupMember}
          sx={{
            position: "absolute",
            bottom: "5rem",
            right: 24,
            zIndex: 10,
            cursor: "pointer",
            background: "#D0021B",
            borderRadius: "50%",
            width: 45,
            height: 45,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          <img
            src={PersonFloat}
            alt="Person Float"
            style={{ width: 20, height: 20 }}
          />
        </Box>
      ) : (
        <></>
      )} */}
    </>
  );
};

// Memoized: re-renders only when its props or store values change, not on
// every render of the page around it (e.g. each keystroke in the message box).
export default React.memo(MessageThreadList);
